export default "__VITE_ASSET__CIzeNM5H__"